import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { Input } from '@tribeplatform/react-ui-kit/Input';
import { T, useI18n } from '../i18n';
export const LinkPicker = ({ placeholder, helper, onChange, }) => {
    const intl = useI18n();
    const [link, setLink] = useState('');
    placeholder =
        placeholder !== null && placeholder !== void 0 ? placeholder : intl.$t({
            id: 'Picker.LinkPicker.DefaultPlaceholder',
            defaultMessage: 'Paste an image link...',
        });
    helper =
        helper !== null && helper !== void 0 ? helper : intl.$t({
            id: 'Picker.LinkPicker.DefaultHelperText',
            defaultMessage: 'Works with any image from the web',
        });
    return (_jsxs("div", { className: "flex flex-col items-center justify-center max-w-full mx-auto", children: [_jsx(Input, { value: link, onChange: e => { var _a; return setLink((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); }, placeholder: placeholder, name: "link", wrapperClassName: "w-full" }, void 0), _jsx(Button, { className: "mt-3", onClick: () => {
                    onChange(link);
                }, children: _jsx(T, { id: "Generics.Submit", defaultMessage: "Submit" }, void 0) }, void 0), _jsx(FormControl.HelperText, { className: "mt-3", children: helper }, void 0)] }, void 0));
};
//# sourceMappingURL=LinkPicker.js.map